function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "./button";
import Scrollbars from "react-custom-scrollbars";
import Chip from "./chip";
import StatusTooltip from "./status_tooltip";
import QuantityEditor from "./quantity_editor";
import IconButton from "./icon_button";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  background-color: #f7f7f7;\n  flex: 1 1 0px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  padding: 5px 10px;\n"])));
var Header = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var HeaderLabel = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #494b50;\n  font-size: 12px;\n  font-weight: 400;\n"])));
var ContentWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n"])));
var SubAccessoriesBOMWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var SelectOptionTypeTitle = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: #2f3136;\n  font-size: 16px;\n  font-weight: 700;\n"])));
var OptionTypesWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 10px;\n  min-height: 35px;\n  max-height: 35px;\n  height: 35px;\n"])));
var ChipWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"])));
var SelectedOptionWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 4px 10px;\n  background-color: white;\n  border: 1px solid #E7E6E6;\n  border-radius: 4px;\n  box-sizing: content-box;\n  min-height: 40px;\n  margin-bottom: 5px;\n  @media (max-width: ", "px) {\n    flex-direction: column;\n    align-items: unset;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var SelectedOptionDescription = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  border-left: 2px solid rgba(98, 100, 105, 0.2);\n  margin-left: 10px;\n  padding-left: 10px;\n  flex: 1 1 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  @media (max-width: ", "px) {\n    border-left: unset;\n    margin-left: 0px;\n    margin-top: 10px;\n    padding-left: 0px;\n    overflow: visible;\n    text-overflow: unset;\n    white-space: unset;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var ActionsWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 10px;\n  align-items: center;\n\n  @media (max-width: ", "px) {\n    margin-left: 0px;\n    margin-top: 10px;\n    justify-content: space-between;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var LinkWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  font-weight: 700;\n  margin-right: 10px;\n"])));
var StatusAndTitleWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var EditAndDeleteWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Content = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""])));
var OptionsContent = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 10px;\n  @media (max-width: ", "px) {\n    flex-direction: column;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var OptionWrapper = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(50% - 10px);\n  padding: 24px 24px 24px 10px;\n  margin-bottom: 15px;\n  margin-right: 10px;\n\n  background: #FFFFFF;\n  border: 1px solid rgba(160, 164, 168, 0.4);\n  border-radius: 4px;\n\n  ", "\n\n  @media (max-width: ", "px) {\n    flex: 1 1 0px;\n    margin-right: 0px;\n  }\n"])), function (props) {
  return props.disabled && 'opacity 0.75; pointer-events: none;';
}, function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var OptionContent = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var OptionImage = styled.img(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  width: 80px;\n  height: 80px;\n  margin-right: 10px;\n  @media (max-width: 400px) {\n    width: 50px;\n    height: 50px;\n  }\n"])));
var DescriptionWrapper = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 5px;\n"])));
var OptionDescription = styled.span(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 12px;\n  color: #626469;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n"])));
var OptionRow = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 5px;\n  justify-content: space-between;\n  align-items: center;\n"])));
var OptionLinkWrapper = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 700;\n"])));
var CategoryDescriptionAndActionsWrapper = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  flex: 1 1 0px;\n"])));
var OptionCol = styled.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  flex-direction: column;\n"])));
var ActionButtonWrapper = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  justify-content: flex-end;\n"])));
var SubAccessoriesManager = /*#__PURE__*/function (_React$Component) {
  _inherits(SubAccessoriesManager, _React$Component);
  var _super = _createSuper(SubAccessoriesManager);
  function SubAccessoriesManager(props) {
    var _this;
    _classCallCheck(this, SubAccessoriesManager);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });
    _defineProperty(_assertThisInitialized(_this), "updateStateIfMounted", function (newState) {
      if (_this._isMounted) {
        _this.setState(newState);
      }
    });
    // Extract the distinct sub accessory types. We get rid of the duplicate types keys.
    _defineProperty(_assertThisInitialized(_this), "extractSubAccessoryTypes", function () {
      var subAccTypes = {};
      var subAccessoryCategories = Object.values(_this.props.subAccessories);
      subAccessoryCategories.forEach(function (subAccCategory) {
        (subAccCategory.optionTypes || []).forEach(function (subAccType) {
          subAccTypes[subAccType.key] = subAccType;
        });
      });
      return Object.values(subAccTypes);
    });
    _defineProperty(_assertThisInitialized(_this), "renderToggleButton", function (accessoryIdentification, numberOfSubAccessories, onClick) {
      var buttonProps;
      if (_this.state.isOpen) {
        buttonProps = {
          id: "".concat(accessoryIdentification.identificationKey, "-subaccessories-close"),
          label: _this.props.getLabel("app.action.close"),
          outline: true,
          color: "#626469",
          textColor: "#626469",
          onClick: onClick
        };
      } else {
        buttonProps = {
          id: "".concat(accessoryIdentification.identificationKey, "-subaccessories-view-all"),
          label: _this.props.getLabel(numberOfSubAccessories === 0 ? "app.action.view" : "app.action.view_all"),
          color: "#626469",
          textColor: "white",
          onClick: onClick
        };
      }
      return /*#__PURE__*/React.createElement(Button, buttonProps);
    });
    _defineProperty(_assertThisInitialized(_this), "renderSubAccessoriesBOM", function () {
      var subAccessoriesWithQuantity = Object.values(_this.props.subAccessories).filter(function (subAcc) {
        return subAcc.quantity > 0;
      });
      return /*#__PURE__*/React.createElement(SubAccessoriesBOMWrapper, null, subAccessoriesWithQuantity.map(function (subAcc, idx) {
        var description = subAcc.getOptionDescription();
        return /*#__PURE__*/React.createElement(SelectedOptionWrapper, {
          mobileBreakpoint: _this.props.mobileBreakpoint,
          key: idx
        }, /*#__PURE__*/React.createElement(StatusAndTitleWrapper, null, subAcc.status && subAcc.status !== 'normal' && /*#__PURE__*/React.createElement(StatusTooltip, {
          status: subAcc.status,
          getLabel: _this.props.getLabel,
          cursor: 'help'
        }), /*#__PURE__*/React.createElement(LinkWrapper, null, _this.props.renderProductLink(subAcc.id))), /*#__PURE__*/React.createElement(SelectedOptionDescription, {
          mobileBreakpoint: _this.props.mobileBreakpoint,
          title: description
        }, description), /*#__PURE__*/React.createElement(ActionsWrapper, {
          mobileBreakpoint: _this.props.mobileBreakpoint
        }, _this.renderQuantity(subAcc), _this.renderActionButtons(subAcc)));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionButton", function (subAcc, addDisabled) {
      return /*#__PURE__*/React.createElement(ActionButtonWrapper, null, subAcc.quantity > 0 && /*#__PURE__*/React.createElement(QuantityEditor, {
        id: "".concat(_this.props.accessoryIdentification.identificationKey, "-").concat(subAcc.subAccessoryIdentification.identificationKey, "-subaccessories"),
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        isSaving: _this.props.isSaving,
        quantity: subAcc.quantity,
        canIncrease: subAcc.canIncrease,
        onIncrease: function onIncrease() {
          _this.props.onAddSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(function () {
            _this.props.raiseNotificationEvent('added', subAcc, 1);
            _this.props.retrieveOptions();
          });
        },
        canDecrease: subAcc.canDecrease || subAcc.quantity === 1 && subAcc.canRemove,
        onDecrease: function onDecrease() {
          _this.props.onDecreaseSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(function () {
            _this.props.raiseNotificationEvent('removed', subAcc, 1);
            _this.props.retrieveOptions();
          });
        }
      }), subAcc.canRemove && subAcc.quantity > 0 && /*#__PURE__*/React.createElement(IconButton, {
        id: "".concat(_this.props.accessoryIdentification.identificationKey, "-").concat(subAcc.subAccessoryIdentification.identificationKey, "-subaccessories-remove"),
        icon: "remove",
        size: 40,
        padding: 7,
        color: '#626469',
        disabled: _this.props.isSaving,
        onClick: function onClick() {
          _this.props.onRemoveSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(function () {
            _this.props.raiseNotificationEvent('removed', subAcc, 1);
            _this.props.retrieveOptions();
          });
        }
      }), (subAcc.quantity == null || subAcc.quantity === 0) && /*#__PURE__*/React.createElement(Button, {
        id: "".concat(_this.props.accessoryIdentification.identificationKey, "-").concat(subAcc.subAccessoryIdentification.identificationKey, "-subaccessories-add"),
        label: _this.props.getLabel('app.action.add'),
        icon: 'plus-large',
        disabled: addDisabled,
        title: subAcc.disabledMessage,
        onClick: function onClick() {
          if (!addDisabled) {
            _this.props.onAddSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(function () {
              _this.props.raiseNotificationEvent('added', subAcc, 1);
              _this.props.retrieveOptions();
            });
          }
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSubAccessoryTypes", function (subAccessoryTypes) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectOptionTypeTitle, null, _this.props.getLabel("options_screen.select_type")), /*#__PURE__*/React.createElement(OptionTypesWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(Scrollbars, null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, subAccessoryTypes.map(function (optType, idx) {
        var selected = _this.state.selectedOptionTypes[optType.key] === true;
        return /*#__PURE__*/React.createElement(ChipWrapper, {
          key: idx
        }, /*#__PURE__*/React.createElement(Chip, {
          disabled: false,
          title: optType.label,
          value: optType.key,
          selected: selected,
          onClick: function onClick() {
            var stateCopy = _objectSpread({}, _this.state.selectedOptionTypes);
            if (selected) {
              delete stateCopy[optType.key];
            } else {
              stateCopy[optType.key] = true;
            }
            _this.updateStateIfMounted({
              selectedOptionTypes: stateCopy
            });
          }
        }));
      })))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderQuantity", function (subAcc) {
      return /*#__PURE__*/React.createElement(QuantityEditor, {
        id: "".concat(_this.props.accessoryIdentification.identificationKey, "-").concat(subAcc.subAccessoryIdentification.identificationKey, "-subaccessories-bom"),
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        isSaving: _this.props.isSaving,
        quantity: subAcc.quantity,
        canIncrease: subAcc.canIncrease,
        onIncrease: function onIncrease() {
          _this.props.onAddSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(function () {
            _this.props.raiseNotificationEvent('added', subAcc, 1);
            _this.props.retrieveOptions();
          });
        },
        canDecrease: subAcc.canDecrease,
        onDecrease: function onDecrease() {
          if (subAcc.quantity === 1) {
            _this.props.onRemoveSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(function () {
              _this.props.raiseNotificationEvent('removed', subAcc, 1);
              _this.props.retrieveOptions();
            });
          } else {
            _this.props.onDecreaseSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(function () {
              _this.props.raiseNotificationEvent('removed', subAcc, 1);
              _this.props.retrieveOptions();
            });
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionButtons", function (subAcc) {
      return /*#__PURE__*/React.createElement(EditAndDeleteWrapper, null, subAcc.canRemove && /*#__PURE__*/React.createElement(IconButton, {
        id: "".concat(_this.props.accessoryIdentification.identificationKey, "-").concat(subAcc.subAccessoryIdentification.identificationKey, "-subaccessories-bom-remove"),
        icon: "remove",
        size: 40,
        padding: 7,
        color: '#626469',
        onClick: function onClick() {
          _this.props.onRemoveSubAccessories(_this.props.deviceIdentification, _this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(function () {
            _this.props.raiseNotificationEvent('removed', subAcc, 1);
            _this.props.retrieveOptions();
          });
        },
        disabled: _this.props.isSaving
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSubAccessoryCategory", function (subAcc) {
      var addDisabled = _this.props.isSaving || !subAcc.canAdd;
      var description = subAcc.getOptionDescription();
      return /*#__PURE__*/React.createElement(OptionWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(OptionContent, null, /*#__PURE__*/React.createElement(OptionImage, {
        src: subAcc.imageUrl
      }), /*#__PURE__*/React.createElement(CategoryDescriptionAndActionsWrapper, null, /*#__PURE__*/React.createElement(OptionCol, null, /*#__PURE__*/React.createElement(OptionLinkWrapper, null, /*#__PURE__*/React.createElement(LinkWrapper, null, _this.props.renderProductLink(subAcc.id)), (subAcc.status === 'recommanded' || subAcc.status === 'mandatory') && /*#__PURE__*/React.createElement(StatusTooltip, {
        fixed: true,
        getLabel: _this.props.getLabel,
        status: subAcc.status
      })), /*#__PURE__*/React.createElement(DescriptionWrapper, null, /*#__PURE__*/React.createElement(OptionDescription, {
        title: description
      }, description))), _this.props.option.quantity > 0 && /*#__PURE__*/React.createElement(OptionRow, null, _this.renderActionButton(subAcc, addDisabled)))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderContent", function (numberOfSubAccessories) {
      var content = /*#__PURE__*/React.createElement(React.Fragment, null);
      if (_this.state.isOpen) {
        var subAccessoryTypes = _this.extractSubAccessoryTypes();
        content = /*#__PURE__*/React.createElement(React.Fragment, null, subAccessoryTypes.length > 0 && _this.renderSubAccessoryTypes(subAccessoryTypes), /*#__PURE__*/React.createElement(OptionsContent, {
          mobileBreakpoint: _this.props.mobileBreakpoint
        }, Object.values(_this.props.subAccessories).filter(function (subAcc) {
          var showSubAcc = true;
          if (subAcc.optionTypes && Object.keys(_this.state.selectedOptionTypes).length > 0) {
            var atLeastOneSubAccFound = false;
            for (var i = 0; i < ((_subAcc$optionTypes = subAcc.optionTypes) === null || _subAcc$optionTypes === void 0 ? void 0 : _subAcc$optionTypes.length) && !atLeastOneSubAccFound; i++) {
              var _subAcc$optionTypes;
              if (_this.state.selectedOptionTypes[subAcc.optionTypes[i].key]) {
                atLeastOneSubAccFound = true;
              }
            }
            showSubAcc = atLeastOneSubAccFound;
          }
          return showSubAcc;
        }).map(function (subAcc, idx) {
          return /*#__PURE__*/React.createElement(Fragment, {
            key: idx
          }, _this.renderSubAccessoryCategory(subAcc));
        })));
      } else if (numberOfSubAccessories > 0) {
        content = /*#__PURE__*/React.createElement(ContentWrapper, null, _this.renderSubAccessoriesBOM());
      }
      return content;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var numberOfSubAccessories = Object.values(_this.props.subAccessories).map(function (subAcc) {
        return subAcc.quantity || 0;
      }).reduce(function (sum, val) {
        return sum + val;
      }, 0);
      return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(HeaderLabel, null, _this.props.getAndReplaceLabel("options_screen.nb_sub_accessories_available", Object.keys(_this.props.subAccessories).length, 'nb')), _this.renderToggleButton(_this.props.accessoryIdentification, numberOfSubAccessories, function () {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      })), /*#__PURE__*/React.createElement(Content, null, _this.renderContent(numberOfSubAccessories)));
    });
    _this.state = {
      isOpen: false,
      subAccessoriesExpanded: false,
      selectedOptionTypes: {}
    };
    _this._isMounted = true;
    return _this;
  }
  return _createClass(SubAccessoriesManager);
}(React.Component);
_defineProperty(SubAccessoriesManager, "propTypes", {
  deviceIdentification: PropTypes.object,
  accessoryIdentification: PropTypes.object,
  option: PropTypes.object,
  renderProductLink: PropTypes.func,
  subAccessories: PropTypes.object,
  getLabel: PropTypes.func,
  getAndReplaceLabel: PropTypes.func,
  mobileBreakpoint: PropTypes.number,
  primaryColor: PropTypes.string,
  primaryTextColor: PropTypes.string,
  onAddSubAccessories: PropTypes.func,
  onDecreaseSubAccessories: PropTypes.func,
  onRemoveSubAccessories: PropTypes.func,
  raiseNotificationEvent: PropTypes.func,
  retrieveOptions: PropTypes.func,
  isSaving: PropTypes.bool
});
export default SubAccessoriesManager;